import { render, staticRenderFns } from "./DictInfo.vue?vue&type=template&id=968d4b10"
import script from "./DictInfo.vue?vue&type=script&lang=js"
export * from "./DictInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports